import React, { cloneElement } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../App";


export default function UnauthenticatedRoute(props) {
    const { state: authState, dispatch: authDispatch } = React.useContext(AuthContext);
    
      const { children } = props;

  if (authState.isAuthenticated) {
    return <Navigate to={"/"} />;
  }

  return cloneElement(children, props);
}